import { render, staticRenderFns } from "./login-pass.vue?vue&type=template&id=be7e1ee6&scoped=true"
import script from "./login-pass.vue?vue&type=script&lang=js"
export * from "./login-pass.vue?vue&type=script&lang=js"
import style0 from "./login-pass.vue?vue&type=style&index=0&id=be7e1ee6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be7e1ee6",
  null
  
)

export default component.exports